var constants = require('../constants');

var dashboardActions = (function() {
    var _setActiveItems = function(activeItems, isSnapShot){
        return {
            type: constants.DASHBOARD_SET_ACTIVE_ITEMS,
            activeItems: activeItems,
            isSnapShot: isSnapShot || false
        };
    }

    var _addActiveItem = function(item) {
        return function(dispatch, getState){
            // dispatch(_setActiveItems(getState().dashboard.activeItems.concat(item)));
            dispatch(_setActiveItems([item]));
        };
    }

    var _removeActiveItem = function(item) {
        return function(dispatch, getState){
            // dispatch(_setActiveItems(getState().dashboard.activeItems.filter(function(activeItem){
            //     return activeItem.id !== item.id;
            // })));
            dispatch(_setActiveItems([]));
        };
    }

    var _clearActiveItems = function() {
        return{
            type: constants.DASHBOARD_CLEAR_ACTIVE_ITEMS
        };
    }

    var _setAlarmSymptomResponses = function(alarmSymptomResponses){
        return {
            type: constants.SET_ALARM_SYMPTOM_RESPONSES,
            data: alarmSymptomResponses
        };
    }

    var _clearDashboard = function(){
        return {
            type: constants.DASHBOARD_CLEAR
        };
    }

    return {
        addActiveItem: _addActiveItem,
        removeActiveItem: _removeActiveItem,
        setActiveItems: _setActiveItems,
        clearActiveItems: _clearActiveItems,
        setAlarmSymptomResponses: _setAlarmSymptomResponses,
        clearDashboard: _clearDashboard
    }
})();

module.exports = dashboardActions;


// WEBPACK FOOTER //
// ./src/common/modules/dashboard/actions/dashboard.js